module.exports = __webpack_public_path__ + "img/invite_banner.e01f6672.jpg";